<template>
  <el-dialog
    v-drag
    v-loading="loading"
    title="查看附件"
    :visible.sync="dialogVisible"
    width="860px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <div class="header">
        <div>
          <span class="label">附件类型</span>
          <el-select v-model="uploadType" placeholder="请选择">
            <el-option
              v-for="item in fileTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="upload-file">
          <span class="label">上传文件</span>
          <el-upload
            class="upload-demo"
            drag
            action="/api/Importer/uploadImporterFile"
            :headers="headers"
            :show-file-list="false"
            :data="{
              importerId: rowData.id,
              uploadType
            }"
            :before-upload="beforeUpload"
            :on-success="onSuccess"
            :on-error="onError"
          >
            <div class="upload-btn">
              <img
                src="@/assets/images/bill/upload.png"
                width="20"
                height="20"
              />点击上传 或 拖拽文件上传
            </div>
          </el-upload>
        </div>
      </div>
      <div class="data">
        <BaseTable
          :height="300"
          :tableData="tableData"
          :isPager="false"
        >
          <template slot="opt" slot-scope="row">
            <el-button type="text" size="small" @click="optFile(row.scope, 0)">查看</el-button>
            <el-button type="text" size="small" @click="optFile(row.scope, 1)">下载</el-button>
          </template>
        </BaseTable>
      </div>
    </div>
  </el-dialog>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable.vue')
import { getImporterFileList, getImporterFileTypeOption } from '@/api/system'
export default {
  components: { BaseTable },
  props: {
    dialogVisible: Boolean,
    rowData: Object
  },
  data() {
    return {
      loading: false,
      fileTypeOptions: [],
      uploadType: '',
      tableData: {
        fileds: [
          {
            filed: 'fileName',
            label: '文件名',
            width: 160
          },
          {
            filed: 'uploadTypeName',
            label: '附件类型',
            width: 160
          },
          {
            filed: 'createdOn',
            label: '上传时间',
            width: 130,
            formatter: (row) =>
              row.createdOn
                ? row.createdOn.slice(0, row.createdOn.length - 9)
                : '--'
          },
          {
            filed: 'createdName',
            label: '上传人',
            width: 120
          },
          {
            filed: 'opt',
            label: '操作',
            width: 160,
            isCustom: true
          }
        ],
        columns: []
      },
      headers: { 'ESCLEARANCE': btoa(`BC5BC301345F4D57CC1A8EF1F74579A7&${Date.now()}`) }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.uploadType = ''
        this.getList()
        this.getFileTypeOptions()
      }
    }
  },
  methods: {
    async getList() {
      try {
        const res = await getImporterFileList({
          importerId: this.rowData.id
        })
        if (res.success) {
          this.tableData.columns = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getFileTypeOptions() {
      try {
        const res = await getImporterFileTypeOption()
        if (res.success) {
          this.fileTypeOptions = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    beforeUpload() {
      if (!this.uploadType) {
        this.$message.warning('请选择附件类型后上传')
        return false
      }
    },
    onSuccess(res) {
      if (res.success) {
        this.getList()
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    onError(err) {
      console.log(err)
    },
    optFile(row, type) {
      if (!type) {
       const suffix = row.fileName.slice(
                row.fileName.lastIndexOf('.') + 1,
                row.fileName.length
            )
            if (
                suffix.toLowerCase() === 'jpg' ||
                suffix.toLowerCase() === 'jpeg' ||
                suffix.toLowerCase() === 'png'
            ) {
                this.$viewerApi({
                    images: row.filePath
                })
            } else if (suffix.toLowerCase() === 'pdf') {
                window.open(
                    row.filePath
                )
            } else {
                this.$message.error('暂时只支持图片和PDF查看')
            }
      } else {
        const elink = document.createElement('a')
        elink.style.display = 'none'
        elink.href = `/api/Importer/previewOrDownload?fileName=${row.fileName}&filePath=${row.filePath}&isLook=false`
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    .label {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      margin-right: 7px;
    }
    .upload-file {
      display: flex;
      align-items: center;
      .upload-btn {
        img {
          margin-right: 10px;
        }
      }
      /deep/ .el-upload-dragger {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 268px;
        height: 40px;
        background: #f7f7f7;
        border-radius: 4px 4px 4px 4px;
        border: 0;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #142e79;
      }
    }
  }
}
</style>
